import styled from '@emotion/styled';

export const Anchor = styled.div`
  height: 0;
  width: 0;
`;
